import * as React from 'react';
import { NASStatus, PassengerFragment } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import CheckoutAdditionalService from '../../../index';
import Button from '../../../../Button/Button';
import { GdsAggregationServiceType } from '../../../../Checkout/types';
import { MoneyType } from '../../../../PriceMatrix/types';

interface Props {
	header: string;
	serviceType: GdsAggregationServiceType;
	description: string;
	coverClassName: string;
	icons?: React.ReactNode[];
	serviceSaving?: boolean;
	travellers: PassengerFragment[];
	selectedSummary?: any;
	priceFrom?: MoneyType;
	totalPrice?: MoneyType;
	isSelected?: boolean;
	openDetails?: () => void;
	onOpen?: () => void;
	selectedServicesText?: {
		name: string;
		terminal?: string;
	}[];
	selectedServicesPassengerNames?: {
		name: string;
		status: NASStatus;
	}[];
	selectedServicesDetailsLink?: string;
	isModifyAvailable?: boolean;
	hideButtons?: boolean;
	renderHeaderPrice?: () => React.ReactNode;
	hideFooterButtons?: boolean;
}

const CommonCard: React.FC<Props> = ({
	header,
	serviceType,
	description,
	coverClassName,
	icons,
	children,
	priceFrom,
	totalPrice,
	isSelected,
	openDetails,
	onOpen,
	selectedServicesText,
	selectedServicesPassengerNames,
	selectedServicesDetailsLink,
	isModifyAvailable,
	hideButtons,
	renderHeaderPrice,
	hideFooterButtons
}) => {
	const { t } = useTranslation('Checkout');
	const { t: aasT } = useTranslation('ServiceAggregation');

	const everyPortTheme = useTheme('CheckoutAdditionalService').EveryPortLounge;

	return (
		<>
			<CheckoutAdditionalService
				mode="aggregator"
				header={header}
				description={description}
				coverClassName={coverClassName}
				isSelected={isSelected}
				addClick={onOpen}
				priceTotal={totalPrice}
				priceFrom={priceFrom}
				aggregationIcons={icons}
				renderHeaderPrice={renderHeaderPrice}
				hideFooterButtons={hideFooterButtons}
				buttons={
					!hideButtons
						? [
								{
									text: t(isModifyAvailable ? 'Change' : 'Details'),
									action: onOpen
								}
						  ]
						: []
				}
				discount={aasT(`${serviceType}_discount`, {
					defaultValue: ''
				})}
			>
				<div>
					{selectedServicesText?.map(text => (
						<span key={text.name}>
							{text.name}
							{text.terminal ? `, ${aasT('Terminal')} ${text.terminal}` : ''}
						</span>
					))}
				</div>

				{selectedServicesPassengerNames?.length > 0 && (
					<ul className={everyPortTheme.services}>
						{selectedServicesPassengerNames.map((passenger, key) => {
							return (
								<li key={key}>
									{passenger.name.toLowerCase()}{' '}
									{passenger.status === NASStatus.Refunded && (
										<span className={everyPortTheme.refunded}> – {aasT('refunded')}</span>
									)}
								</li>
							);
						})}
					</ul>
				)}

				{!hideFooterButtons && (
					<div className={everyPortTheme.details}>
						{children}

						{selectedServicesDetailsLink && (
							<div>
								<Button variant="text" className={everyPortTheme.details__button} onClick={openDetails}>
									{t('Details')}
								</Button>
							</div>
						)}
					</div>
				)}
			</CheckoutAdditionalService>
		</>
	);
};

export default CommonCard;
